(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["mk-product-reference"] && !Shopify.designMode) return;
  try {
    (async () => {
    const { StandardEvents } = await import('@shopify/events');

    class MkProductReference extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section');
        this.section?.addEventListener(StandardEvents.productSelect, this.updateReference);
      }

      disconnectedCallback() {
        this.section?.removeEventListener(StandardEvents.productSelect, this.updateReference);
      }

      updateReference = (event) => {
        if (event.target instanceof Element && event.target.closest('product-card')) return;
        event.promise?.then(({ detail }) => {
          if (!detail) return;
          if (detail.newProduct) this.dataset.productId = detail.newProduct.id;
          if (detail.productId && String(detail.productId) !== this.dataset.productId) return;
          const value = this.querySelector('[data-reference-value]');
          if (value && detail.resource) {
            value.textContent = detail.resource.sku || this.dataset.productId;
          }
        }).catch((error) => {
          if (error?.name !== 'AbortError') console.warn('[product-reference]', error);
        });
      };
    }

    if (!customElements.get('mk-product-reference')) {
      customElements.define('mk-product-reference', MkProductReference);
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
